export default {
    fileStorage: {
        table: {
            StorageCode: '存储编码',
            policy: '文件名前缀策略',
            DomainName: '域名',
            control: 'bucket权限控制',
            bucket: 'bucket前缀',
            Default: '默认',
            Created: '创建人',
            CreationTime: '创建时间',
            Operation: '操作',
        },
        dialog: {
            StorageCode: '存储编码',
            policy: '文件名前缀策略',
            DomainName: '域名',
            RegionBucket: 'bucket所属地区',
            controlBucket: 'bucket权限控制',
            bucketPrefix: 'bucket前缀',
            AutomaticallyBucket: '自动创建bucket',
            Default: '默认',
            EditConfiguration: '编辑存储配置',
            CreateConfiguration: '新建存储配置',
        },
        common: {
            StorageType: '存储类型',
            Tenant: '租户',
        },
    },
};
